import { mapGetters } from "vuex";

export default {
  data: () => ({
    article:[
      {
        id: 2,
        title: 'Что такое безопасная сделка? ',
        text: 'Безопасная сделка - опция, доступная на нашем портале. Она обеспечивает защиту интересов и адвоката, и его доверителя. В процессе оказания юридических услуг у клиента может возникнуть недовольство некачественной помощью адвоката. В свою очередь, адвокат заинтересован в том, чтобы.... ',
        href: '/article/what-is-a-secure-transaction',
        img: '/static/img/show_art_all.png',
        isHide: false,
      },
      {
        id: 3,
        title: 'Как строить работу с адвокатом, чтобы достичь максимального результата?',
        text: 'В жизни бывают ситуации, когда без адвоката сложно решить проблему. Люди живут своей жизнью, ходят на работу, воспитывают детей и тут .... ',
        href: '/article/how-to-work-with-a-lawyer-to-achieve-maximum-results',
        img: '/static/img/show_art_all.png',
        isHide: false,
      },
      {
        id: 4,
        title: 'Лжеюристы в России.',
        text: 'В последнее время в России появилось немало коммерческих организаций, которые позиционируют себя как профессиональные юристы, проводят агрессивную рекламную компанию, заманивают людей, у которых возникла юридическая проблема, и обещают 100-процентный результат. Получив деньги, эти лже-правоведы в лучшем случае ....',
        href: '/article/lzheyuristi-v-rossii',
        img: '/static/img/show_art_all.png',
        isHide: false,
      },
      {
        id: 5,
        title: 'Что важно знать,  если вас вызвали на допрос к следователю.',
        text: 'По закону вызвать любого человека для дачи показаний может суд, следователь, дознаватель. Вызов сопровождается вручением повестки. Однако на практике следователь может ....',
        href: '/article/what-is-important-to-know-if-you-were-summoned-for-interrogation-by-the-investigator',
        img: '/static/img/show_art_all.png',
        isHide: false,
      },
    ],
  }),

  methods: {
  },
  computed: {
    ...mapGetters([])
  },
}


// WEBPACK FOOTER //
// ./src/pages/Article/articleOne/articleOne.js